// import {
//   Action,
//   combineReducers,
//   configureStore,
//   ThunkAction,
// } from "@reduxjs/toolkit";
// import {
//   persistStore,
//   persistReducer,
//   FLUSH,
//   REHYDRATE,
//   PAUSE,
//   PERSIST,
//   PURGE,
//   REGISTER,
// } from "redux-persist";
// import storage from "redux-persist/lib/storage";

// import {
//   authApi,
//   businessUnitApi,
//   gradeApi,
//   sectorsApi,
//   subAdminApi,
//   companiesApi,
//   gradeSetupApi,
//   salaryRangeApi,
//   cashAllowancesApi,
//   shortTermIPApi,
//   longTermIPApi,
//   internalPayrollDataApi,
//   marketDataApi,
//   offersApi,
//   jobFunctionsApi,
//   companySubAdmins,
//   emailTemplateApi
// } from "@services";
// import { authReducer } from "./auth";
// import { businessUnitReducer } from "./business-unit";
// import { sectorsReducer } from "./sectors";
// import { gradeReducer } from "./grade";
// import { emailReducer } from "./email-template";
// import { subAdminReducer } from "./sub-admin";
// import { companiesReducer } from "./companies";
// import { countriesReducer } from "./countries";
// import {
//   ISectorsState,
//   ISubAdminReducer,
//   IAuthState,
//   IBusinessUnitState,
// } from "@types";
// import { offersReducer } from "./offers";

// export interface ICombineReducerProps {
//   auth: IAuthState;
//   businessUnit: IBusinessUnitState;
//   subAdmin: ISubAdminReducer;
//   sectors: ISectorsState;
// }

// const appReducer = combineReducers({
//   [authApi.reducerPath]: authApi.reducer,
//   [businessUnitApi.reducerPath]: businessUnitApi.reducer,
//   [sectorsApi.reducerPath]: sectorsApi.reducer,
//   [gradeApi.reducerPath]: gradeApi.reducer,
//   [companiesApi.reducerPath]: companiesApi.reducer,
//   [subAdminApi.reducerPath]: subAdminApi.reducer,
//   [gradeSetupApi.reducerPath]: gradeSetupApi.reducer,
//   [salaryRangeApi.reducerPath]: salaryRangeApi.reducer,
//   [cashAllowancesApi.reducerPath]: cashAllowancesApi.reducer,
//   [shortTermIPApi.reducerPath]: shortTermIPApi.reducer,
//   [longTermIPApi.reducerPath]: longTermIPApi.reducer,
//   [internalPayrollDataApi.reducerPath]: internalPayrollDataApi.reducer,
//   [marketDataApi.reducerPath]: marketDataApi.reducer,
//   [offersApi.reducerPath]: offersApi.reducer,
//   [jobFunctionsApi.reducerPath]: jobFunctionsApi.reducer,
//   [companySubAdmins.reducerPath]: companySubAdmins.reducer,
//   [emailTemplateApi.reducerPath]: emailTemplateApi.reducer,
//   auth: authReducer,
//   businessUnit: businessUnitReducer,
//   sectors: sectorsReducer,
//   grade: gradeReducer,
//   subAdmin: subAdminReducer,
//   companies: companiesReducer,
//   countries: countriesReducer,
//   offers: offersReducer,
// });

// const persistConfig = {
//   key: "root",
//   version: 1,
//   storage,
//   whitelist: ["auth"],
// };

// const rootReducer = (state: any, action: any) => {
//   if (
//     action?.meta?.arg?.endpointName === "logout" &&
//     action?.type === "authApi /executeMutation/fulfilled"
//   ) {
//     state = {} as RootState;
//     localStorage.clear();
//   }

//   return appReducer(state, action);
// };

// const persistedReducer = persistReducer(persistConfig, rootReducer);

// export const store = configureStore({
//   reducer: persistedReducer,
//   devTools:
//     process.env.NODE_ENV !== "production" && typeof window !== "undefined",
//   middleware: getDefaultMiddleware => [
//     ...getDefaultMiddleware({
//       serializableCheck: {
//         ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
//       },
//     }),
//     authApi.middleware,
//     sectorsApi.middleware,
//     gradeApi.middleware,
//     companiesApi.middleware,
//     gradeSetupApi.middleware,
//     salaryRangeApi.middleware,
//     cashAllowancesApi.middleware,
//     shortTermIPApi.middleware,
//     longTermIPApi.middleware,
//     internalPayrollDataApi.middleware,
//     marketDataApi.middleware,
//     offersApi.middleware,
//     jobFunctionsApi.middleware,
//     companySubAdmins.middleware,
//     emailTemplateApi.middleware,
//   ],
// });

// window.store = store;
// export const persistor = persistStore(store);

// export type RootState = ReturnType<typeof rootReducer>;
// export type AppDispatch = typeof store.dispatch;

// export type AppThunk<ReturnType = void> = ThunkAction<
//   ReturnType,
//   RootState,
//   unknown,
//   Action<string>
// >;

import {
  Action,
  combineReducers,
  configureStore,
  ThunkAction,
} from "@reduxjs/toolkit";
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";

import {
  authApi,
  businessUnitApi,
  gradeApi,
  sectorsApi,
  subAdminApi,
  companiesApi,
  gradeSetupApi,
  salaryRangeApi,
  cashAllowancesApi,
  shortTermIPApi,
  longTermIPApi,
  internalPayrollDataApi,
  marketDataApi,
  offersApi,
  jobFunctionsApi,
  companySubAdmins,
  emailTemplateApi,
  dashboardApi,
  aiSuggestionApi
} from "@services";
import { authReducer } from "./auth";
import { businessUnitReducer } from "./business-unit";
import { sectorsReducer } from "./sectors";
import { gradeReducer } from "./grade";
import { emailReducer } from "./email-template";
import { subAdminReducer } from "./sub-admin";
import { companiesReducer } from "./companies";
import { countriesReducer } from "./countries";
import {
  ISectorsState,
  ISubAdminReducer,
  IAuthState,
  IBusinessUnitState,
} from "@types";
import { offersReducer } from "./offers";

export interface ICombineReducerProps {
  auth: IAuthState;
  businessUnit: IBusinessUnitState;
  subAdmin: ISubAdminReducer;
  sectors: ISectorsState;
}

const appReducer = combineReducers({
  [authApi.reducerPath]: authApi.reducer,
  [businessUnitApi.reducerPath]: businessUnitApi.reducer,
  [sectorsApi.reducerPath]: sectorsApi.reducer,
  [gradeApi.reducerPath]: gradeApi.reducer,
  [companiesApi.reducerPath]: companiesApi.reducer,
  [subAdminApi.reducerPath]: subAdminApi.reducer,
  [gradeSetupApi.reducerPath]: gradeSetupApi.reducer,
  [salaryRangeApi.reducerPath]: salaryRangeApi.reducer,
  [cashAllowancesApi.reducerPath]: cashAllowancesApi.reducer,
  [shortTermIPApi.reducerPath]: shortTermIPApi.reducer,
  [longTermIPApi.reducerPath]: longTermIPApi.reducer,
  [internalPayrollDataApi.reducerPath]: internalPayrollDataApi.reducer,
  [marketDataApi.reducerPath]: marketDataApi.reducer,
  [offersApi.reducerPath]: offersApi.reducer,
  [jobFunctionsApi.reducerPath]: jobFunctionsApi.reducer,
  [companySubAdmins.reducerPath]: companySubAdmins.reducer,
  [emailTemplateApi.reducerPath]: emailTemplateApi.reducer,
  [dashboardApi.reducerPath]: dashboardApi.reducer,
  [aiSuggestionApi.reducerPath]: aiSuggestionApi.reducer,
  auth: authReducer,
  businessUnit: businessUnitReducer,
  sectors: sectorsReducer,
  grade: gradeReducer,
  subAdmin: subAdminReducer,
  companies: companiesReducer,
  countries: countriesReducer,
  offers: offersReducer,
});

const persistConfig = {
  key: "root",
  version: 1,
  storage,
  whitelist: ["auth"],
};

const rootReducer = (state: any, action: any) => {
  if (
    action?.meta?.arg?.endpointName === "logout" &&
    action?.type === "authApi /executeMutation/fulfilled"
  ) {
    state = {} as RootState;
    localStorage.clear();
  }

  return appReducer(state, action);
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  devTools:
    process.env.NODE_ENV !== "production" && typeof window !== "undefined",
  middleware: getDefaultMiddleware => [
    ...getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
    authApi.middleware,
    sectorsApi.middleware,
    gradeApi.middleware,
    companiesApi.middleware,
    gradeSetupApi.middleware,
    salaryRangeApi.middleware,
    cashAllowancesApi.middleware,
    shortTermIPApi.middleware,
    longTermIPApi.middleware,
    internalPayrollDataApi.middleware,
    marketDataApi.middleware,
    offersApi.middleware,
    jobFunctionsApi.middleware,
    companySubAdmins.middleware,
    emailTemplateApi.middleware,
    dashboardApi.middleware,
    aiSuggestionApi.middleware,
  ],
});

window.store = store;
export const persistor = persistStore(store);

export type RootState = ReturnType<typeof rootReducer>;
export type AppDispatch = typeof store.dispatch;

export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
